import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSiteContext } from "../../context/SiteContext";

import HomeIcon from "../../images/icons/home.svg";
import RoomsIcon from "../../images/icons/rooms.svg";
import RecordingsIcon from "../../images/icons/recordings.svg";
import ElementsIcon from "../../images/icons/elements.svg";
import SessionsIcon from "../../images/icons/sessions.svg";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { user } = useSiteContext();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkIsDesktop = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkIsDesktop();
    window.addEventListener("resize", checkIsDesktop);

    return () => window.removeEventListener("resize", checkIsDesktop);
  }, []);
  const allNavigationItems = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: <img className="h-6 w-4" alt="Home" src={HomeIcon} />,
      requiresPlan: false,
    },
    {
      name: "Rooms",
      href: "/dashboard/rooms",
      icon: <img className="h-6 w-4" alt="Rooms" src={RoomsIcon} />,
      requiresPlan: true,
    },
    {
      name: "Recordings",
      href: "/dashboard/recordings",
      icon: <img className="h-6 w-4" alt="Recordings" src={RecordingsIcon} />,
      requiresPlan: false,
    },
    {
      name: "Elements",
      href: "/dashboard/folders",
      icon: <img className="h-6 w-4" alt="Elements" src={ElementsIcon} />,
      requiresPlan: true,
    },
    {
      name: "Sessions",
      href: "/dashboard/sessions",
      icon: <img className="h-6 w-4" alt="Sessions" src={SessionsIcon} />,
      requiresPlan: false,
    },
  ];

  // Filter navigation items based on user plan
  const navigation = allNavigationItems.filter((item) => {
    if (!item.requiresPlan) {
      return true; // Always show items that don't require a plan
    }
    // Only show "Rooms" and "Elements" if user has a valid plan (Basic or Business)
    return user && user.plan && (user.plan === "Basic" || user.plan === "Business");
  });

  // const handleLogout = () => {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("user");
  //   localStorage.removeItem("meetingRole");
  //   localStorage.removeItem("meetingId");
  //   localStorage.removeItem("meetingToken");
  //   localStorage.removeItem("meetingMicOn");
  //   localStorage.removeItem("meetingWebcamOn");
  //   window.location.href = "/login";
  // };

  return (
    <div
      className={`fixed left-0 top-16 md:top-16 h-[calc(100%-4rem)] transition-all duration-300 z-30 transform ${
        isOpen
          ? "translate-x-0 w-56"
          : "-translate-x-full w-56 md:translate-x-0 md:w-16"
      }  `}
      style={{
        backgroundColor: isOpen
          ? isDesktop
            ? "transparent"
            : "#2A2835"
          : "transparent",
      }}
    >
      {/* Logo/Brand */}
      {/* <div className="bg-black border-b border-gray-200 flex items-center justify-start p-4">
        <img src={RlinkFav} alt="logo" className="w-12 h-12" />
      </div> */}

      {/* Navigation */}
      <nav className="">
        <div className="space-y-8 pt-24">
          <h3 className="text-white px-3 uppercase text-lg">Admin Panel</h3>
          {navigation.map((item) => {
            const isActive =
              location.pathname === item.href ||
              (item.href === "/dashboard" &&
                location.pathname === "/dashboard") ||
              (item.name === "Elements" &&
                (location.pathname.includes("/folders") ||
                  location.pathname.includes("/elemets") ||
                  location.pathname.includes("/elements")));
            return (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={() => {
                  // Emit event when clicking Dashboard link to reset any open forms
                  if (item.href === "/dashboard") {
                    window.dispatchEvent(new Event("dashboard-clicked"));
                  }
                  // Close sidebar on mobile when clicking a menu item
                  if (!isDesktop && toggleSidebar) {
                    toggleSidebar();
                  }
                }}
                className={`flex items-center py-2 text-base md:text-[15px] transition-colors duration-200 cursor-pointer font-medium ${
                  isActive
                    ? "bg-primaryPurple text-white pl-0 pr-3"
                    : "text-gray-300 hover:bg-gray-600/50 hover:text-white pl-3 pr-3"
                }`}
              >
                <div className={`flex items-center ${isActive ? "pl-3" : ""}`}>
                  <span className="flex-shrink-0 mr-3">{item.icon}</span>
                  {isOpen && <span>{item.name}</span>}
                </div>
              </NavLink>
            );
          })}
        </div>
      </nav>

      {/* Bottom Section */}
      {/* <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-600">
        {isOpen && user && (
          <div className="flex flex-col gap-3">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center">
                  <img
                    src={user?.logo || "/r-logo.png"}
                    alt="logo"
                    className="w-8 h-8 rounded-full"
                  />
                </div>
              </div>
              <div className="ml-3 min-w-0">
                <p className="text-sm font-medium text-white truncate">
                  {user?.name || ""}
                </p>
                <p className="text-xs text-gray-400 truncate">
                  {user?.email || ""}
                </p>
              </div>
            </div>
            <button
              onClick={() => {
                handleLogout();
              }}
              className="w-full px-3 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
            >
              <LogOut className="h-5 w-5" />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div> */}

      <div className="hidden md:block absolute top-24 bottom-24 right-0 translate-x-8 w-px bg-white/30 pointer-events-none" />
    </div>
  );
};

export default Sidebar;
